import React from 'react';
import { Rocket } from 'lucide-react';
import { Text, Button } from '../ui';

const UpgradeCard = ({ onUpgrade }) => {
  return (
    <div
      className='tour-upgrade-card rounded-xl flex flex-col items-center justify-center p-8 text-center h-full min-h-[300px] cursor-pointer transition-colors'
      style={{
        background: 'var(--bg-surface)',
        border: '1px dashed var(--border)',
      }}
      onClick={onUpgrade}
    >
      <div
        className='w-12 h-12 rounded-full flex items-center justify-center mb-4'
        style={{ background: 'rgba(251,191,36,0.15)', color: '#f59e0b' }}
      >
        <Rocket className='w-6 h-6' />
      </div>
      <Text variant='subtitle' className='font-bold mb-1' style={{ color: 'var(--text-primary)' }}>
        Unlock More Posts
      </Text>
      <Text variant='caption' className='mb-6 max-w-xs' style={{ color: 'var(--text-body)' }}>
        Upgrade to see all your scheduled content
      </Text>
      <Button
        variant='primary'
        onClick={(e) => {
          e.stopPropagation();
          onUpgrade();
        }}
        className='w-full max-w-[200px]'
      >
        Upgrade Now
      </Button>
    </div>
  );
};

export default UpgradeCard;
